import { render, staticRenderFns } from "./epms5070_soltec.vue?vue&type=template&id=82fca03e&scoped=true"
import script from "./epms5070_soltec.vue?vue&type=script&lang=js"
export * from "./epms5070_soltec.vue?vue&type=script&lang=js"
import style0 from "./epms5070_soltec.vue?vue&type=style&index=0&id=82fca03e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fca03e",
  null
  
)

export default component.exports